<template>
  <div style="text-align: left">
    <div style="margin-bottom: 10px">
      <el-button
        type="primary"
        v-role="['1', '3']"
        class="add"
        size="small"
        @click="addTeamRegistrationConfig"
      >
        <i class="el-icon-plus"></i>
        新增团体舞价格设置
      </el-button>
      <el-button
        type="danger"
        v-role="['1', '3']"
        size="small"
        class="delete"
        @click="delMulData"
      >
        <i class="el-icon-delete"></i>删除
      </el-button>
    </div>
    <div>
      <div class="box">
        <el-form :inline="true" size="mini">
          <el-form-item>
            <el-input
              placeholder="请输入..."
              clearable
              v-model="searchForm.name"
            ></el-input>
          </el-form-item>
          <el-button
            type="primary"
            size="small"
            @click="doSearch"
            class="queryBtn"
            >查询</el-button
          >
        </el-form>
      </div>
    </div>
    <el-table
      ref="multipleTable"
      :data="tableListData"
      tooltip-effect="dark"
      style="width: 100%; position: relative"
      :row-class-name="tableRowClassName"
      @selection-change="handleSelectionChange"
    >
      <el-table-column
        type="selection"
        min-width="40"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="startPeroid"
        align="center"
        label="开始区间"
      ></el-table-column>
      <el-table-column
        prop="endPeroid"
        align="center"
        label="结束区间"
      ></el-table-column>
      <el-table-column
        prop="price"
        align="center"
        label="报名价格"
      ></el-table-column>
      <el-table-column
        prop="competitionGroupId"
        align="center"
        label="适用组别"
      ></el-table-column>
      <el-table-column
        prop="operation"
        label="操作"
        width="100"
        fixed="right"
        v-role="['1', '3']"
        align="center"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <el-button
            type="text"
            v-role="['1', '3']"
            @click="deleteTeamRegistrationConfig(scope.row)"
            class="btn"
            size="small"
            >删除</el-button
          >
          <el-button
            type="text"
            size="small"
            v-role="['1', '3']"
            @click="editTeamRegistrationConfig(scope.row)"
            class="btn"
            >编辑</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <div class="paging">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="searchForm.page"
        :page-sizes="[15, 20, 50, 100]"
        :page-size="searchForm.pageSize"
        background
        layout="prev, pager, next,total, sizes, jumper"
        :total="total"
      ></el-pagination>
    </div>
    <!--新增弹框-->
    <el-dialog
      :title="formTitle"
      :inline="true" :destroy-on-close="true"
      :visible.sync="dialogFormVisible"
    >
      <el-form
        :model="form"
        label-position="right"
        label-width="110px"
        :rules="formRules"
        ref="form"
      >
        <el-form-item label="起始区间" prop="startPeroid">
          <el-input-number
            v-model="form.startPeroid"
            :controls="false"
            :precision="0"
            maxlength="255"
          ></el-input-number>
        </el-form-item>
        <el-form-item label="结束区间" prop="endPeroid">
          <el-input-number
            v-model="form.endPeroid"
            :controls="false"
            :precision="0"
            maxlength="255"
          ></el-input-number>
        </el-form-item>
        <el-form-item label="价格" prop="price">
          <el-input-number
            v-model="form.price"
            :controls="false"
            :precision="2"
            maxlength="255"
          ></el-input-number>
        </el-form-item>
        <el-form-item label="适用组别" prop="competitionGroupId">
          <el-select
            multiple
            filterable
            clearable
            v-model="form.competitionGroupId"
            style="width: 100%"
          >
            <el-option
              v-for="item in groupOptions"
              :value="item.value"
              :label="item.name"
              :key="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="计算模式" prop="computeMode">
           <el-radio-group v-model="form.computeMode">
             <el-radio :label="1">按实际人数计算</el-radio>
             <el-radio :label="2">按区间最大值计算</el-radio>
             <el-radio :label="3">按区间最小值计算</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitForm" :loading="isLoading"
          >确 定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>
<script>
import API from "../apis/teamregistrationconfig";
import GroupApi from "../apis/group";

export default {
  props: ["matchId"],
  data() {
    return {
      isLoading: false,
      formTitle:'新增配置',
      dialogFormVisible: false,
      multipleSelection: [],
      total: 0,
      showMatchTeamRegistrationConfig: false,
      tableListData: [],
      searchForm: {
        matchId: this.matchId,
        page: 1,
        pageSize: 15,
      },
      form: {
        id: 0,
        startPeroid: "",
        endPeroid: "",
        price: "",
        competitionGroupId: null,
        matchId: this.matchId,
        computeMode:1
      },
      groupOptions: [],
      formRules: {
        startPeroid: [
          { required: true, message: "请输入起始区间", trigger: "blur" },
        ],
        endPeroid: [
          { required: true, message: "请输入结束区间", trigger: "blur" },
        ],
        price: [{ required: true, message: "请输入报名费", trigger: "blur" }],
        competitionGroupId: [
          { required: true, message: "请输入组别", trigger: "blur" },
        ],
        ComputeMode:[{ required: true, message: "请选择计费模式", trigger: "blur" }]
      },
    };
  },
  methods: {
    tableRowClassName({ row, rowIndex }) {
      if (rowIndex % 2 == 0) {
        return "warning-row";
      } else {
        return "success-row";
      }
    },
    editTeamRegistrationConfig(row) {
      this.formTitle = "编辑配置";
      API.get({ id: row.id }).then((result) => {
        this.dialogFormVisible = true;
        this.form = Object.assign({}, result.result);
        if (
          this.form.competitionGroupId != null &&
          this.form.competitionGroupId != ""
        ) {
          this.form.competitionGroupId =
            this.form.competitionGroupId.split(",");
        }
      });
    },
    addTeamRegistrationConfig() {
            this.formTitle = "新增配置";    
      this.dialogFormVisible = true; 
      this.$nextTick(() => {
        this.$refs["form"].resetFields();      
       this.form.id = 0;
        this.form.startPeroid='';
        this.form.price = '';
        this.form.endPeroid='';
        this.form.competitionGroupId=null;
        this.form.matchId=this.matchId;
        this.form.computeMode=1;
      });
    },
    handleSizeChange: function (val) {
      this.searchForm.pageSize = val;
      this.search();
    },
    handleCurrentChange: function (val) {
      this.searchForm.page = val;
      this.search();
    },
    doSearch() {
      this.searchForm.page = 1;
      this.search();
    },
    search: function () {
      let params = Object.assign({}, this.searchForm);
      API.getList(params)
        .then((result) => {
          if (result && result.code == 0) {
            this.tableListData = result.result.data;
            this.total = result.result.recordCount;
          } else {
            this.$message.error({
              showClose: true,
              message: result.result.message,
              duration: 2000,
            });
          }
        })
        .catch((error) => {
          this.$message.error({
            showClose: true,
            message: "请求出现异常",
            duration: 2000,
          });
        });
    },

    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    submitForm() {
      let that = this;
      this.isLoading = true;
      this.$refs.form.validate((valid) => {
        if (valid) {
          let params = Object.assign({}, this.form);
          if (params.competitionGroupId instanceof Array) {
            params.competitionGroupId = params.competitionGroupId.join();
          }
          if (params.id > 0) {
            API.edit(params)
              .then(
                (data) => {
                  if (data.code == 0) {
                    that.$message.success({
                      showClose: true,
                      message: "更改成功",
                      duration: 2000,
                    });
                    that.dialogFormVisible = false;
                    that.$refs["form"].resetFields();
                    that.search();
                  } else {
                    this.$message.error({
                      showClose: true,
                      message: "更新失败",
                      duration: 2000,
                    });
                  }
                  that.isLoading = false;
                },
                function (err) {
                  that.$message.error({
                    showClose: true,
                    message: err.toString(),
                    duration: 2000,
                  });
                  that.isLoading = false;
                }
              )
              .catch(function (error) {
                that.$message.error({
                  showClose: true,
                  message: "请求出现异常",
                  duration: 2000,
                });
                that.isLoading = false;
              });
          } else {
            API.add(params)
              .then((result) => {
                if (result.code == 0) {
                  this.$message.success({
                    showClose: true,
                    message: "新增成功",
                    duration: 2000,
                  });
                  this.$refs["form"].resetFields();
                  this.dialogFormVisible = false;
                  this.search();
                  this.isLoading = false;
                } else {
                  this.$message.error({
                    showClose: true,
                    message: "新增失败",
                    duration: 2000,
                  });
                  this.isLoading = false;
                }
              })
              .catch((error) => {
                this.$message.error({
                  showClose: true,
                  message: "请求异常",
                  duration: 2000,
                });
                this.isLoading = false;
              });
          }
        } else {
          this.isLoading = false;
        }
      });
    },
    deleteTeamRegistrationConfig(row) {
      let params = { id: row.id };
      this.$confirm("确认删除记录吗？", "提示", { type: "warning" })
        .then(() => {
          API.delete(params)
            .then((result) => {
              console.log(result);
              if (result.code == 0) {
                this.$message.success({
                  showClose: true,
                  message: "删除成功",
                  duration: 2000,
                });
                this.search();
              } else {
                this.$message.error({
                  showClose: true,
                  message: "系统错误",
                  duration: 2000,
                });
              }
            })
            .catch((error) => {
              this.$message.error({
                showClose: true,
                message: "123",
                duration: 2000,
              });
            });
        })
        .catch(() => {});
    },
    /*批量删除*/
    delMulData() {
      let that = this;
      let val = that.multipleSelection;
      let idArray = [];
      for (var i = 0; i < val.length; i++) {
        idArray.push(val[i].id);
      }
      this.$confirm("此操作将永久删除该数据，是否继续？", "提示", {
        confimButtonTexe: "确定",
        cancelButtonTexe: "取消",
        type: "warning",
      }).then(() => {
        if (idArray) {
          API.deleteBatch({ ids: idArray.join() })
            .then(
              function (result) {
                that.loading = false;
                if (result && result.code == 0) {
                  that.$message.success({
                    showClose: true,
                    message: "删除成功",
                    duration: 2000,
                  });
                  that.search();
                } else {
                  that.$message.error({
                    showClose: true,
                    message: "删除操作异常，请重试",
                    duration: 2000,
                  });
                }
              },
              function (err) {
                that.loading = false;
                that.$message.error({
                  showClose: true,
                  message: err.toString(),
                  duration: 2000,
                });
              }
            )
            .catch(function (error) {
              that.loading = false;
              console.log(error);
              that.$message.error({
                showClose: true,
                message: "请求出现异常",
                duration: 2000,
              });
            });
        }
      });
      this.$refs.multipleTable.clearSelection();
    },
  },
  mounted() {
    this.search();
    GroupApi.select({ matchId: this.matchId }).then((res) => {
      this.groupOptions = res.result;
    });
  },
};
</script>


// WEBPACK FOOTER //
// src/components/TeamRegistrationConfig.vue